export class BrowserService {

    static createMetaTag(property, content) {
        const tag = document.createElement('meta');
        tag.setAttribute('property', property);
        tag.content = content;
        return tag;
    }

    static createMetaNameTag(name, content) {
        const tag = document.createElement('meta');
        tag.name = name;
        tag.content = content;
        return tag;
    }

    static metaTag(seoData) {
        try {
            document.querySelectorAll('meta[name="robots"]')
                .forEach(tag => tag.remove())
            document.querySelectorAll('meta[name="googlebot"]')
                .forEach(tag => tag.remove())
            const keys = ['og:title', 'og:url', 'og:description', 'og:image', 'og:image:width', 'og:image:height']
            keys.forEach(key => {
                document.querySelectorAll(`meta[property="${key}"]`)
                    .forEach(tag => tag.remove())
            })
            const nameKeys = ['description', 'twitter:title', 'twitter:description', 'twitter:image']
            nameKeys.forEach(key => {
                document.querySelectorAll(`meta[name="${key}"]`)
                    .forEach(tag => tag.remove())
            })
            if (process.env.REACT_APP_SEO === 'true') {
                if (seoData) {
                    const tags = [
                        BrowserService.createMetaTag('og:title', seoData.title),
                        BrowserService.createMetaTag('og:url', window.location.origin + window.location.pathname),
                        BrowserService.createMetaNameTag('twitter:card', 'summary'),
                        BrowserService.createMetaNameTag('twitter:title', seoData.title)
                    ];
                    tags.push(BrowserService.createMetaTag('og:description', seoData.text));
                    tags.push(BrowserService.createMetaNameTag('description', seoData.text));
                    if (seoData.image) {
                        tags.push(...[
                            BrowserService.createMetaTag('og:image', seoData.image.url),
                            BrowserService.createMetaTag('og:image:width', seoData.image.width),
                            BrowserService.createMetaTag('og:image:height', seoData.image.height),
                            BrowserService.createMetaNameTag('twitter:image', seoData.image.url)
                        ])
                    }
                    document.head.append(...tags);
                } else {
                    document.title = 'LITEVIEW株式会社（ライトビュー株式会社）';
                    const tags = [
                        BrowserService.createMetaNameTag('description', 'LITEVIEWはあなたの新事業・DX戦略を支援します。'),
                        BrowserService.createMetaTag('og:title', 'LITEVIEW株式会社（ライトビュー株式会社）'),
                        BrowserService.createMetaTag('og:url', 'https://corporate.liteview.jp/'),
                        BrowserService.createMetaTag('og:description', 'LITEVIEWはあなたの新事業・DX戦略を支援します。'),
                        BrowserService.createMetaTag('og:image', 'https://liteview.jp/static/assets/corporate_ogp.png'),
                        BrowserService.createMetaTag('og:image:width', '1200'),
                        BrowserService.createMetaTag('og:image:height', '630'),
                        BrowserService.createMetaNameTag('twitter:title', 'LITEVIEW株式会社（ライトビュー株式会社）'),
                        BrowserService.createMetaNameTag('twitter:description', 'LITEVIEWはあなたの新事業・DX戦略を支援します。'),
                        BrowserService.createMetaNameTag('twitter:image', 'https://liteview.jp/static/assets/corporate_ogp.png')
                    ];
                    document.head.append(...tags);
                }
            } else {
                BrowserService.addNoIndex();
            }
        } catch (e) {
            console.error(e);
        }
    }

    static addNoIndex() {
        try {
            const tag1 = document.createElement('meta');
            tag1.name = 'robots';
            tag1.content = 'noindex';
            document.head.appendChild(tag1);
            const tag2 = document.createElement('meta');
            tag2.name = 'googlebot';
            tag2.content = 'noindex';
            document.head.appendChild(tag2);
            const tag3 = document.createElement('meta');
            tag3.name = 'robots';
            tag3.content = 'nofollow';
            document.head.appendChild(tag3);
            const tag4 = document.createElement('meta');
            tag4.name = 'googlebot';
            tag4.content = 'nofollow';
            document.head.appendChild(tag4);
        } catch (e) {
            console.error(e);
        }
    }

    static shouldAsyncLoadByScroll(target) {
        if (target && target.scrollTop) {
            const range = target.scrollTop / (target.scrollHeight - target.offsetHeight);
            return range > 0.98;
        } else {
            return false;
        }
    }
}

const BASE_URL = process.env.REACT_APP_CONTACT_API;
// const BASE_URL = 'https://pulit.ap.ngrok.io/';

export class APIService {
    static getMediaCount() {
        return fetch(`${BASE_URL}subscription/web/owned-media/count`)
            .then((r) => r.json())
            .then(res => {
                return parseInt(res.data, 10);
            }).catch(e => {
                console.error(e)
                return Promise.resolve(0)
            })
    }

    static ownedMediaList(pageNum, pageRow) {
        return fetch(`${BASE_URL}subscription/web/owned-media/list?pageNum=${pageNum}&pageRow=${pageRow}&sort=0`)
            .then((r) => r.json())
            .then(res => {
                if (res.data && res.data.value) {
                    return res.data.value;
                }
                return [];
            }).catch(e => {
                console.error(e)
                return Promise.reject(e)
            })
    }

    static ownedMedia(uid) {
        return fetch(`${BASE_URL}subscription/web/owned-media/${uid}`)
            .then((r) => r.json())
            .then(res => {
                return res.data;
            }).catch(e => {
                console.error(e)
                return Promise.reject(e)
            })
    }
}



// WEBPACK FOOTER //
// ./src/util.js